import { render } from "./forgot.html?vue&type=template&id=c06eddb2&external"
import script from "./forgot.vue?vue&type=script&lang=js"
export * from "./forgot.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__